module.exports = __webpack_public_path__ + "img/soh1_small.9b39d9a2.jpg";